module.exports = __webpack_public_path__ + "static/media/photo_2.196014c0.jpg";